// Mercury motion system: lightweight parallax for elements opted in via
// [data-mercury-parallax]. No-ops entirely under prefers-reduced-motion.
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prefersReducedMotion.matches) return;

  var elements = Array.prototype.slice.call(document.querySelectorAll('[data-mercury-parallax]'));
  if (!elements.length) return;

  var ticking = false;
  var viewportHeight = window.innerHeight;

  function update() {
    ticking = false;
    elements.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      var progress = (rect.top + rect.height / 2 - viewportHeight / 2) / viewportHeight;
      var strength = parseFloat(el.getAttribute('data-mercury-parallax')) || 16;
      var offset = Math.max(-1, Math.min(1, progress)) * strength;
      el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('resize', function () {
    viewportHeight = window.innerHeight;
    onScroll();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
